import React from 'react'
import widgetsService from 'live/services/widgets'
import { widgetWrapper } from 'live/widgets/decorators/pure'
import BHAChart from './BHAChart'
import dataReducer from './dataReducer'
import { addNewEditor } from '../common/editorRegister'
import i18n from 'live/services/i18n'
import thumbnail from '../../../assets/img/bha.png'
import { Fields } from '../editor'
import AssetSelector from '../editor/fields/AssetSelector'
import ObjectSelector from '../editor/fields/ObjectSelector'
import AxesSizeConfig from '../../configurations/AxesSizeConfig'

const type = 'bha'

widgetsService.name(type, 'BHA')
widgetsService.description(type, 'BHA Overview')
widgetsService.impl(
    type,
    widgetWrapper(BHAChart, dataReducer, {
        mapConfigToRender(configs) {
            return {
                widget: configs.widget,
                dashboardTheme: configs.dashboardContext.theme
            }
        },
        sampleTime: 500
    })
)
widgetsService.policies(type, {
    layers: 1,
    allowYAxisConfig: false,
    allowGroupedYAxis: false,
    defaultReducer: 'list(*) every 1000 items => @chain',
    handleOwnMissingData: true
})

widgetsService.queryHandlerKind(type, 'bha')

widgetsService.properties(type, {})
widgetsService.config(type, {
    objectType: 'trajectory',
    span: 'ts 0 to ts 8000',
    numberOfVisibleAxes: 6,
    spanPicker: {
        type: 'depth',
        configs: {
            depth: {}
        }
    }
})

addNewEditor(
    {
        type,
        order: 11,
        label: i18n('BHA'),
        description: i18n('Visualize last BHA in the current trajectory'),
        thumbnail: thumbnail
    },
    [
        <Fields name={'channels'}>
            <AssetSelector label={'Asset'} editorOnly={true} />
            <ObjectSelector objectType={'trajectory'} label={'Trajectory'} />
        </Fields>,
        <Fields>
            <AxesSizeConfig configField={'numberOfVisibleAxes'} label={i18n('Size of axes area')} />
        </Fields>
    ]
)
